// extracted by mini-css-extract-plugin
module.exports = {"closeButton":"styles_closeButton__QqE__","closeIcon":"styles_closeIcon__hW_pv","menuCloseButton":"styles_menuCloseButton__alK6K"};